import { useQuery } from "@tanstack/react-query";
import api from "./__api__/forms";
import type { Form } from "../types/form/Form";
import { isItem } from "../types/item";
import { getItem, getItemPath } from "./__api__/surveys";
import { format } from "date-fns";
// import { FiltersProps as BaseFiltersProps } from "./filter";

interface FormFilter {
  createdAt: string;
}

// export interface FiltersProps extends BaseFiltersProps {
//   owner?: string | undefined;
//   order?: OrderFilter | undefined;
//   page?: number | undefined;
// }
//
// export const useQuerySurvey = <TData extends Survey>(data: TData, session: any) => {
//   return useQuery({
//     queryKey: [getItemPath(data?.id || data["id"])],
//     queryFn: getItem(data?.id || data["id"], session),
//     enabled: !!data?.id || !!data["id"]
//   });
// };

export const useQueryForms = (session: any, page?: string | string[] | undefined) => {
  return useQuery({
    queryKey: [api.getFormsPath(page)],
    queryFn: api.getForms(page, session),
  });
};

export default { useQueryForms };